export const DOORS_PER_ROOM = 6;

export const LEVELS = {
  facile: { rooms: 10, minDist: 2, time: 480000 },
  normale: { rooms: 16, minDist: 3, time: 480000 },
  incubo: { rooms: 24, minDist: 4, time: 1500000, allDoors: true },
};

const rand = (n) => Math.floor(Math.random() * n);

const bfs = (links, start) => {
  const dist = Array(links.length).fill(-1);
  dist[start] = 0;
  const q = [start];
  while (q.length) {
    const r = q.shift();
    for (const l of links[r]) {
      if (l.type === "room" && dist[l.to] < 0) {
        dist[l.to] = dist[r] + 1;
        q.push(l.to);
      }
    }
  }
  return dist;
};

const shuffle = (a) => {
  for (let i = a.length - 1; i > 0; i--) {
    const j = rand(i + 1);
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

// Door d of room A is paired with door d of room B (two-way). One exit, far from the start room.
export function generateMaze(level = "normale") {
  const { rooms: ROOMS, minDist } = LEVELS[level];
  for (;;) {
    const links = Array.from({ length: ROOMS }, () => Array(DOORS_PER_ROOM).fill(null));
    for (let d = 0; d < DOORS_PER_ROOM; d++) {
      const free = shuffle([...Array(ROOMS).keys()].filter((r) => !links[r][d]));
      for (let i = 0; i + 1 < free.length; i += 2) {
        links[free[i]][d] = { type: "room", to: free[i + 1], door: d };
        links[free[i + 1]][d] = { type: "room", to: free[i], door: d };
      }
      if (free.length % 2) links[free[free.length - 1]][d] = { type: "room", to: free[free.length - 1], door: d };
    }
    const key = LEVELS[level].allDoors ? 1 + rand(ROOMS - 1) : -1;
    // All-doors levels: no fixed exit, the last uncrossed passage becomes the way out.
    if (LEVELS[level].allDoors) {
      if (bfs(links, 0).some((d) => d < 0)) continue;
      return { links, exit: null, key };
    }
    // Exit goes in one of the rooms farthest from the start.
    const d0 = bfs(links, 0);
    const far = Math.max(...d0);
    if (far < minDist || d0.some((d) => d < 0)) continue;
    const rooms = d0.flatMap((d, r) => (d === far ? [r] : []));
    const room = rooms[rand(rooms.length)];
    const doors = [...Array(DOORS_PER_ROOM).keys()].filter((d) => links[room][d].type === "room");
    const door = doors[rand(doors.length)];
    const partner = links[room][door].to;
    links[room][door] = { type: "exit" };
    if (partner !== room) links[partner][door] = { type: "room", to: partner, door };
    const exit = { room, door };
    const dist = bfs(links, 0);
    if (!dist.every((d) => d >= 0)) continue;
    return { links, exit, key };
  }
}
